import { render, staticRenderFns } from "./VentaPasoCuatro.vue?vue&type=template&id=23dacf20"
import script from "./VentaPasoCuatro.vue?vue&type=script&lang=js"
export * from "./VentaPasoCuatro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports